class SalToast {
    constructor(options) {
        this.options = {
            toastArea: "sal-toast__area",
            animationClass: "show",
            timeout: 5000
        };

        this.types = {
            INFO: "sal-toast--info",
            ERROR: "sal-toast--error",
            MESSAGE: "sal-toast--message"
        };

        Object.assign(this.options, options);

        this.toastArea = document.querySelector(`.${this.options.toastArea}`)

        if (!this.toastArea) {
            this.toastArea = document.createElement("div");
            this.toastArea.classList.add(this.options.toastArea);
            document.body.appendChild(this.toastArea);
        }
    }

    createToast(title, subtitle, type, button, body = null, image = null, group = null, errorMessage = null) {
        const div = document.createElement("div");
        const content = document.createElement("div");
        content.classList.add("background");
        div.classList.add("sal-toast", type);

        content.innerHTML += `
            <span class="sal-toast__icon button button--secondary button--icon icon--before icon--close" aria-label='close'></span>
        `;

        if (title && title.length) {
            content.innerHTML += `
                <p class="sal-toast__title">${title}</p>
            `;
        }

        if (subtitle && subtitle.length) {
            content.innerHTML += `
                <p class="sal-toast__subtitle">${subtitle}</p>
            `;
        }

        let imageElement = '';
        if (image && image.src) {
            imageElement = `
                <img class="sal-toast__image img-fluid ${image.showMobile ? 'show-mobile' : ''}" src="${image.src}" alt="${image.alt}" />
            `;
        }

        if (image) {
            if (image.link) {
                content.innerHTML += `
                <a href="${image.link}" target="${image.target}">
                    ${imageElement}
                </a>
            `;
            } else {
                content.innerHTML += imageElement;
            }
        }

        if (body && body.length) {
            content.innerHTML += `
                <p class="sal-toast__body">${body}</p>
            `;
        }


        if (button && button.link) {
            content.innerHTML += `<div class="button-wrapper bottom left"><a href="${button.link}" target="${button.target ? button.target : '_blank'}" class="sal-toast__button ${button.additionalClass ? button.additionalClass : ''}">${button.label}</a></div>`
        }

        if (type === this.types.ERROR) {
            content.innerHTML += `<p class="sal-toast__error-message">${errorMessage}</p>`;
        }

        div.appendChild(content);

        this.toastArea.appendChild(div);
        setTimeout(() => {
            div.classList.add(this.options.animationClass);
        }, 100);

        if (this.options.timeout) {
            const timer = setTimeout(() => {
                div.classList.add("hide");
                div.addEventListener('transitionend', () => {
                    this.toastArea.removeChild(div);
                    window.dispatchEvent(new CustomEvent('toastClosed', {
                        bubbles: true,
                        detail: group ? group : ''
                    }));
                });
            }, this.options.timeout);

            div.querySelector('.icon--close').addEventListener('click', () => {
                clearTimeout(timer);
                div.classList.add("hide");
                div.addEventListener('transitionend', () => {
                    this.toastArea.removeChild(div);
                    window.dispatchEvent(new CustomEvent('toastClosed', {
                        bubbles: true,
                        detail: group ? group : ''
                    }));
                });
            });
        } else {
            div.querySelector('.icon--close').addEventListener('click', () => {
                div.classList.add("hide");
                div.addEventListener('transitionend', () => {
                    this.toastArea.removeChild(div);
                    window.dispatchEvent(new CustomEvent('toastClosed', {
                        bubbles: true,
                        detail: group ? group : ''
                    }));
                });
            });
        }
    }
}

export {SalToast}
